import * as log from 'loglevel'

const findClarifyingQuestionsAction = (data) => {
  try {
    // Try to parse as JSON
    const message_orig_json = JSON.parse(data.message);
    if(message_orig_json !== null) {
      // check if message_orig_json is an array
      let found_ClarifyingQuestionsAction = null;
      if(Array.isArray(message_orig_json)) {
        if(message_orig_json.length > 0) {
          message_orig_json.forEach((item) => {
            if(item.action_class === 'ClarifyingQuestionsAction') {
              found_ClarifyingQuestionsAction = item;
            }
          });
        }
      }
      else {
        if(message_orig_json.action_class === 'ClarifyingQuestionsAction') {
          found_ClarifyingQuestionsAction = message_orig_json;
        }
      }
      if(found_ClarifyingQuestionsAction !== null) {
        if(found_ClarifyingQuestionsAction['deep_agent_id'] !== undefined && found_ClarifyingQuestionsAction['deep_agent_id'] !== null && found_ClarifyingQuestionsAction['outputs'] !== null && found_ClarifyingQuestionsAction['outputs'] !== undefined) {
          // parse outputs as JSON
          if(typeof found_ClarifyingQuestionsAction['outputs'] === 'string') {
            found_ClarifyingQuestionsAction['outputs'] = JSON.parse(found_ClarifyingQuestionsAction['outputs']);
          }
          // check if message is in outputs
          if(found_ClarifyingQuestionsAction['outputs']['message'] !== undefined && found_ClarifyingQuestionsAction['outputs']['message'] !== null) {
            // check if deep_agent_id is a string and convert to int
            if(typeof found_ClarifyingQuestionsAction['deep_agent_id'] === 'string') {
              found_ClarifyingQuestionsAction['deep_agent_id'] = parseInt(found_ClarifyingQuestionsAction['deep_agent_id']);
            } 

            // check if parseInt succeeded
            if(isNaN(found_ClarifyingQuestionsAction['deep_agent_id'])) {
              log.error('Error parsing deep_agent_id:', found_ClarifyingQuestionsAction['deep_agent_id']);
              return null;
            }

            return {
              deep_agent_id: found_ClarifyingQuestionsAction['deep_agent_id'],
              message: found_ClarifyingQuestionsAction['outputs']['message']
            };
          }
        }    
      }
    }
    return null;
  }
  catch (error) {
    log.error('Error parsing JSON:', error);
    return null;
  }
}

export { findClarifyingQuestionsAction };
